<script setup lang="ts">
import { defineProps, defineEmits, withDefaults } from 'vue';

const props = withDefaults(defineProps<{
  id: string,
  acceptedFileTypes?: string[],
  multiple?: boolean
}>(), {
  acceptedFileTypes: () => ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
  multiple: false,
})

const emit = defineEmits([
  'fileInput',
]);

const handleFileInput = (e: Event) => {
  const target = e.target as HTMLInputElement;
  const files = target.files;

  if (files && files.length > 0) {
    emit('fileInput', files);
  }

  // Reset the input value to allow re-uploading the same file
  target.value = '';
}
</script>

<template>
  <div class="media-uploader">
    <input
      type="file"
      :id="props.id"
      :accept="acceptedFileTypes.join(',')"
      :multiple="multiple"
      @change="handleFileInput"
    />
  </div>

</template>